import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: 'dcf321d0-f77f-40d7-a466-9b582731f4e8',
        authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
        redirectUri: import.meta.env.PROD ? 'https://innovation.zps.siemens.com' : window.location.origin,
        postLogoutRedirectUri: import.meta.env.PROD ? 'https://innovation.zps.siemens.com' : window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest: RedirectRequest = {
    scopes: ['User.Read'],
};

export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

// API configuration
export interface ApiConfig {
    baseUrl: string;
    scopes: string[];
}

export const apiConfig: ApiConfig = {
    // Production: Use SWA-bundled API
    // Development: Use local Functions emulator
    baseUrl: import.meta.env.PROD
        ? '/api'
        : 'http://localhost:7071/api',
    // We must request a token for OUR application
    scopes: ['dcf321d0-f77f-40d7-a466-9b582731f4e8/.default'],
};
